import React, { Component } from "react";
import { Button, Modal } from "antd";
import SurveyStepOneRender from "./children/SurveyStepOneRender";
import SurveyStepTwoRender from "./children/SurveyStepTwoRender";
import SurveyStepThreeRender from "./children/SurveyStepThreeRender";
import SurveySuccessRender from "./children/SurveySuccessRender";
import { ReactComponent as LifestyleIcon } from "../../../assets/icons/survey-lifestyle.svg";
import { ReactComponent as BusinessIcon } from "../../../assets/icons/survey-business.svg";
import { ReactComponent as CompanyIcon } from "../../../assets/icons/survey-company.svg";
import { ReactComponent as LongNameIcon } from "../../../assets/icons/survey-long-name.svg";
import { ReactComponent as MarketingIcon } from "../../../assets/icons/survey-marketing.svg";
import { ReactComponent as OtherIcon } from "../../../assets/icons/survey-other.svg";
import { ReactComponent as SocialIcon } from "../../../assets/icons/survey-social.svg";
import { ReactComponent as ToolsIcon } from "../../../assets/icons/survey-tools.svg";
import travelImg from "../../../assets/images/survey-travel.png";
import animalImg from "../../../assets/images/survey-animal.png";
import arrowImg from "../../../assets/images/survey-arrow.png";
import birthdayImg from "../../../assets/images/survey-birthday.png";
import bodyImg from "../../../assets/images/survey-body.png";
import fashionImg from "../../../assets/images/survey-fashion.png";
import foodImg from "../../../assets/images/survey-food.png";
import longNameImg from "../../../assets/images/survey-longName.png";
import musicImg from "../../../assets/images/survey-music.png";
import photographyImg from "../../../assets/images/survey-photography.png";
import sportImg from "../../../assets/images/survey-sport.png";
import weddingImg from "../../../assets/images/survey-wedding.png";
import utils from "../../../../../utils/utils";
import { requsetChangeAppearance } from "../../../api/apis";
import i18n from "../../../../../locales/i18n";
import {
  GASignUpQuestionnaireFirst,
  GASignUpQuestionnaireSeconds,
  GASignUpQuestionnaireTheme,
  GASignUpQuestionnaireClickOK,
} from "../../../ga/signUp";

export default class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0, //问卷进行的步骤
      stepOneChooseList: [], //问卷一的选择key
      stepTwoChooseList: [], //问卷二的选择key
      stepThreeChooseList: [], //问卷三的选择key
      stepOnePurposeList: [], //问卷一选项
      stepTwoPurposeList: [], //问卷二选项
      surveySubmitStatus: false, //问卷提交成功的状态，true为提交成功
      submitting: false, //是否正在提交问卷数据
    };
  }

  componentDidMount() {
    this.initShufflePurposeList();
  }

  /**
   * 初始化选项，用于打乱选项的需求
   */
  initShufflePurposeList = () => {
    //问卷一的选项打乱
    const stepOnePurposeList = [
      {
        key: 1,
        title: i18n.t("loginAndSignUp:surveyAnswer1"),
        value: "Lifestyle Video",
        icon: () => <LifestyleIcon />,
      },
      {
        key: 2,
        title: i18n.t("loginAndSignUp:surveyAnswer2"),
        value: "Business Video",
        icon: () => <BusinessIcon />,
      },
      {
        key: 3,
        title: i18n.t("loginAndSignUp:surveyAnswer3"),
        value: "Company Video",
        icon: () => <CompanyIcon />,
      },
      {
        key: 4,
        title: i18n.t("loginAndSignUp:surveyAnswer6"),
        value: "Slideshow Video",
        icon: () => <LongNameIcon />,
      },
      {
        key: 5,
        title: i18n.t("loginAndSignUp:surveyAnswer4"),
        value: "Marketing Video",
        icon: () => <MarketingIcon />,
      },
      {
        key: 6,
        title: i18n.t("loginAndSignUp:surveyAnswer5"),
        value: "Social Media Video",
        icon: () => <SocialIcon />,
      },
      {
        key: 7,
        title: i18n.t("loginAndSignUp:surveyAnswer7"),
        value: "Video Tool",
        icon: () => <ToolsIcon />,
      },
    ];
    const stepOneshuffleList = utils.shuffle(stepOnePurposeList);
    stepOneshuffleList.push({
      key: 8,
      title: i18n.t("loginAndSignUp:surveyAnswerOther"),
      value: "Other",
      icon: () => <OtherIcon />,
    });

    //问卷二的选项打乱
    const stepTwoPurposeList = [
      {
        key: 1,
        title: i18n.t("loginAndSignUp:surveyAnswer8"),
        value: "Travel Video",
        imgSrc: travelImg,
      },
      {
        key: 2,
        title: i18n.t("loginAndSignUp:surveyAnswer12"),
        value: "Animal Video",
        imgSrc: animalImg,
      },
      {
        key: 3,
        title: i18n.t("loginAndSignUp:surveyAnswer10"),
        value: "Birthday Video",
        imgSrc: birthdayImg,
      },
      {
        key: 4,
        title: i18n.t("loginAndSignUp:surveyAnswer11"),
        value: "Baby Video",
        imgSrc: bodyImg,
      },
      {
        key: 5,
        title: i18n.t("loginAndSignUp:surveyAnswer14"),
        value: "Fashion Video",
        imgSrc: fashionImg,
      },
      {
        key: 6,
        title: i18n.t("loginAndSignUp:surveyAnswer13"),
        value: "Food Video",
        imgSrc: foodImg,
      },
      {
        key: 7,
        title: i18n.t("loginAndSignUp:surveyAnswer15"),
        value: "Holiday Video",
        imgSrc: longNameImg,
      },
      {
        key: 8,
        title: i18n.t("loginAndSignUp:surveyAnswer18"),
        value: "Music Video",
        imgSrc: musicImg,
      },
      {
        key: 9,
        title: i18n.t("loginAndSignUp:surveyAnswer9"),
        value: "Wedding Video",
        imgSrc: weddingImg,
      },
      {
        key: 10,
        title: i18n.t("loginAndSignUp:surveyAnswer17"),
        value: "Photography Video",
        imgSrc: photographyImg,
      },
      {
        key: 11,
        title: i18n.t("loginAndSignUp:surveyAnswer16"),
        value: "Sport Video",
        imgSrc: sportImg,
      },
    ];
    const stepTwoshuffleList = utils.shuffle(stepTwoPurposeList);
    stepTwoshuffleList.push({
      key: 12,
      title: i18n.t("loginAndSignUp:surveyAnswerOther"),
      value: "Other",
      imgSrc: arrowImg,
    });
    this.setState({
      stepOnePurposeList: stepOneshuffleList,
      stepTwoPurposeList: stepTwoshuffleList,
    });
  };

  /**
   * 切换步骤
   * @param {Number} step 上一步就是-1，下一步就是1
   */
  handleChangeStep = step => {
    this.setState({
      step: this.state.step + step,
    });
  };

  /**
   * 选择问卷内容
   * @param {String} listKey 当前文件对应state中的list的key，如问卷一的则是stepOneChooseList
   * @param {Number} key 选择的key
   */
  handleChangeChooseList = (listKey, key) => {
    let chooseList = [...this.state[listKey]];
    //因为问卷三是单选的，所以直接替换数组
    if (listKey === "stepThreeChooseList") {
      chooseList = [key];
    } else {
      if (chooseList.some(item => item === key)) {
        chooseList = chooseList.filter(item => item !== key);
      } else {
        chooseList.push(key);
      }
    }
    this.setState({
      [listKey]: chooseList,
    });
  };

  /**
   * 提交问卷
   */
  handleDoneSurvey = () => {
    const { stepOneChooseList, stepTwoChooseList, stepThreeChooseList, stepOnePurposeList, stepTwoPurposeList } = this.state;

    this.setState({
      submitting: true,
    });

    //埋点上报用户问卷填写信息
    let GAQuestionnaireFirstList = stepOnePurposeList.filter(item => stepOneChooseList.indexOf(item.key) !== -1).map(item => item.value);
    GASignUpQuestionnaireFirst(GAQuestionnaireFirstList.join(", "));
    let GAQuestionnaireSecondList = stepTwoPurposeList.filter(item => stepTwoChooseList.indexOf(item.key) !== -1).map(item => item.value);
    GASignUpQuestionnaireSeconds(GAQuestionnaireSecondList.join(", "));
    GASignUpQuestionnaireTheme(stepThreeChooseList.length ? (stepThreeChooseList[0] === "light" ? "Light theme" : "Dark theme") : "");

    if (stepThreeChooseList.length) {
      this.handleRequsetChangeAppearance(stepThreeChooseList[0] === "light" ? "Light" : "Dark");
    }
  };

  /**
   * 判断下一步按钮是否可以点击
   * @returns 按钮的disabled属性，true即不能点击，false可以点击
   */
  checkBtnIsDisable = () => {
    let disabled = false;
    const { step, stepOneChooseList, stepTwoChooseList, stepThreeChooseList } = this.state;
    if (step === 0 && !stepOneChooseList.length) {
      disabled = true;
    } else if (step === 1 && !stepTwoChooseList.length) {
      disabled = true;
    } else if (step === 2 && !stepThreeChooseList.length) {
      disabled = true;
    }
    return disabled;
  };

  /**
   *请求修改用户主题
   * @param {string} appearance Dark || Light 接口需要的参数首字母大写
   */
  handleRequsetChangeAppearance = appearance => {
    let formData = new FormData();
    formData.append("appearance", appearance);
    requsetChangeAppearance({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          console.log("设置成功");
          this.setState({
            surveySubmitStatus: true,
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  };

  /**
   *成功弹窗点击ok按钮
   */
  handleSurveyOk = () => {
    this.props.handleSurveyClose(false);
    //埋点
    GASignUpQuestionnaireClickOK();
  };

  render() {
    const { visible, handleSurveyClose } = this.props;
    return (
      <>
        <Modal
          centered
          visible={visible}
          maskClosable={false}
          title={null}
          onCancel={handleSurveyClose}
          footer={null}
          width={this.state.surveySubmitStatus ? 460 : 948}
        >
          {this.state.surveySubmitStatus ? (
            <div className="survey-cont px-0 px-sm-4 py-4">
              <SurveySuccessRender handleSurveyOk={this.handleSurveyOk} />
            </div>
          ) : (
            <div className="survey-cont px-0 px-sm-4 py-4">
              <h3 className="text-center fw-bold mb-4">{i18n.t("loginAndSignUp:surveyTitle")}</h3>
              {this.state.step === 0 ? (
                <SurveyStepOneRender
                  purposeList={this.state.stepOnePurposeList}
                  stepOneChooseList={this.state.stepOneChooseList}
                  handleChangeChooseList={key => this.handleChangeChooseList("stepOneChooseList", key)}
                />
              ) : this.state.step === 1 ? (
                <SurveyStepTwoRender
                  purposeList={this.state.stepTwoPurposeList}
                  stepTwoChooseList={this.state.stepTwoChooseList}
                  handleChangeChooseList={key => this.handleChangeChooseList("stepTwoChooseList", key)}
                />
              ) : (
                <SurveyStepThreeRender
                  stepThreeChooseList={this.state.stepThreeChooseList}
                  handleChangeChooseList={key => this.handleChangeChooseList("stepThreeChooseList", key)}
                />
              )}
              <div className="step-btns overflow-hidden mt-5 pt-32">
                {this.state.step !== 0 && (
                  <Button className="back-btn fw-bolder fs-6" onClick={() => this.handleChangeStep(-1)} type="primary" ghost size="large">
                    {i18n.t("loginAndSignUp:surveyBackBtn")}
                  </Button>
                )}
                {this.state.step !== 2 && (
                  <Button
                    className="next-btn fw-bolder fs-6"
                    disabled={this.checkBtnIsDisable()}
                    onClick={() => this.handleChangeStep(1)}
                    type="primary"
                    size="large"
                  >
                    {i18n.t("loginAndSignUp:surveyNextBtn")}
                  </Button>
                )}
                {this.state.step === 2 && (
                  <Button
                    disabled={this.checkBtnIsDisable()}
                    className="next-btn fw-bolder fs-6"
                    onClick={this.handleDoneSurvey}
                    type="primary"
                    size="large"
                    loadding={this.state.submitting}
                  >
                    {i18n.t("loginAndSignUp:surveyDoneBtn")}
                  </Button>
                )}
              </div>
            </div>
          )}
        </Modal>
      </>
    );
  }
}
